module.exports = __webpack_public_path__ + "static/media/599.705493 (2).1e1737b9.pdf";